module.exports = __webpack_public_path__ + "img/infibo-faq-screenshot-ru.fe57b0c3.png";